import { ReactNode } from 'react'
import { MediaType } from '@/constants/constants'

interface IKeyValues {
  key: string
  value: string
}

export interface Dependency {
  field: string
  value: any
  rules: Partial<{
    required: boolean
    visible?: boolean
  }>
}

export type IFormFieldType =
  | {
      type: 'String' | 'Content' | 'Number' | 'date' | 'datetime-local' | 'month' | 'time' | 'week'
      validate?: (value: string) => boolean
      label: string
      min?: number
      max?: number
      required?: boolean
      children?: never
      variant?: IFormFieldType
      dependencies?: Array<Dependency>
    }
  | {
      type: 'Image' | 'Video' | 'Doc'
      label: string
      min?: number
      max?: number
      required?: boolean
      children?: never
      variant?: IFormFieldType
      dependencies?: Array<Dependency>
    }
  | {
      type: 'Boolean'
      label: string
      min?: never
      max?: never
      required?: boolean
      children?: never
      variant?: IFormFieldType
      dependencies?: Array<Dependency>
    }
  | {
      type: 'Radio' | 'Select'
      label: string
      min?: never
      validate?: (value: string) => boolean
      max?: never
      options: Array<IKeyValues>
      required?: boolean
      multiple?: boolean
      children?: never
      variant?: IFormFieldType
      dependencies?: Array<Dependency>
    }
  | {
      type: 'List'
      min?: number
      label: string
      max?: number
      required?: boolean
      variant?: IFormFieldType
      children: { [key: string]: IFormFieldType }
      dependencies?: Array<Dependency>
    }
  | {
      type: 'Object'
      min?: never
      max?: never
      label: string
      required?: boolean
      children: { [key: string]: IFormFieldType }
      variant?: IFormFieldType
      dependencies?: Array<Dependency>
    }
  | {
      type: 'Media'
      label: string
      min?: number
      max?: number
      required?: boolean
      children?: never
      variant?: IFormFieldType
      dependencies?: Array<Dependency>
      mediaTypes: MediaType[]
    }
export interface IPageDataContext {
  pageData: any
}
export interface IWidget<P> {
  id: string
  name: string
  icon?: ReactNode
  placements?: Array<string>
  defaultProps: P
  formType: { [key: string]: IFormFieldType }
  render: (props: P, pageData?: any) => React.ReactElement
}

function createWidget<P>(widget: IWidget<P>): IWidget<P> {
  return widget
}

export default createWidget
